<wbo-bi-filter-page [title]="entityModel.data.name">
    <wbo-page-navs>
        <wbo-page-nav>
            <wbo-bi-page-select-nav></wbo-bi-page-select-nav>
        </wbo-page-nav>
        <wbo-page-nav>
            <fui-nav-button (click)="reset()" [title]="'wbo.common.button.reset'">
                <fui-icon [height]="12" [icon]="'reset'" [width]="12"></fui-icon>
            </fui-nav-button>
        </wbo-page-nav>
    </wbo-page-navs>

    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="dateRangeRef">
                <wbo-date-range-single-select-search-control [cube]="cubeDefinition?.cubeName"></wbo-date-range-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="[Outlet].[location].[location]">
                <wbo-location-multi-select-search-control></wbo-location-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-bi-filter-extended-fields [cubeDefinition]="cubeDefinition"></wbo-bi-filter-extended-fields>
        </wbo-search-form-extended-fields>
    </wbo-search-form>

    <wbo-bi-server-status-indicator *ngIf="serverStatusModel.isInitialising()"></wbo-bi-server-status-indicator>

    <div class="pivot-view" *ngIf="serverStatusModel.isInitialised()">
        <wbo-bi-view-page-header [restrictions]="model.restriction$ | async"
                                 [rowsTruncated]="model.data?.rowsTruncated"
                                 [columnsTruncated]="model.data?.columnsTruncated"
                                 (reset)="reset()"
                                 (refresh)="refresh()" [showRefresh]="true"
                                 (edit)="edit()" [showEdit]="editable"
                                 (clone)="clone()" [showClone]="clonable"
                                 (delete)="delete()" [showDelete]="deletable">
        </wbo-bi-view-page-header>

        <wbo-bi-pivot-grid [height]="gridHeight"></wbo-bi-pivot-grid>
    </div>

    <wbo-footer-spinner [label]="'wbo.common.label.generatingReport'"
                        [processing]="reportGenerationService.running$ | async">
    </wbo-footer-spinner>
</wbo-bi-filter-page>
